<template>
  <div class="page-solutions">
    <SolutionsChapter1 />
    <SolutionsChapter1a />    
    <SolutionsChapter2 />
    <SolutionsChapter3 />
    <ScrollTopBtn />
  </div>
</template>

<script>
import SolutionsChapter1a from '@/components/views/solutions/SolutionsChapter1a'
import SolutionsChapter1 from '@/components/views/solutions/SolutionsChapter1'
import SolutionsChapter2 from '@/components/views/solutions/SolutionsChapter2'
import SolutionsChapter3 from '@/components/views/solutions/SolutionsChapter3'

import ScrollTopBtn from '@/components/layout/ScrollTopButton'

export default {
  name: 'SolutionsPage',
  components: {
    SolutionsChapter1a,
    SolutionsChapter1,
    SolutionsChapter2, 
    SolutionsChapter3,
    ScrollTopBtn
  },
  data() {
    return {
      publicPath: process.env.BASE_URL,
    };
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
</style>